import {cn} from '@tempmee/core'
import {Box, Row, Typography} from '@tempmee/react'
import type {ReactNode} from 'react'

export interface SectionHeaderProps {
  /** Section title. A string is wrapped in a bold `subtitle1`; pass a node for full control. */
  title: ReactNode
  /** Optional trailing action pinned to the right (e.g. an overflow menu or a link). */
  action?: ReactNode
  className?: string
}

/**
 * Internal: the title + optional action row shared by `ChartCard`, `TableCard`,
 * and `ActivityList`. Keeps the card-header treatment in one place so the section
 * blocks stay consistent. Not a public export.
 */
export function SectionHeader({title, action, className}: SectionHeaderProps) {
  return (
    <Row align="center" justify="between" gap={2} className={cn('min-w-0', className)}>
      {typeof title === 'string' ? (
        // 18px bold — a clear step above the 16px-bold DS table column headers so the
        // section title reads as the card's heading, not another header row.
        <Typography
          variant="subtitle1"
          as="span"
          className="truncate text-[1.125rem] leading-tight text-text-primary"
        >
          {title}
        </Typography>
      ) : (
        title
      )}
      {action != null && <Box className="shrink-0">{action}</Box>}
    </Row>
  )
}
